import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/api/dashboard.api';
import { dispatchesApi } from '@/api/dispatches.api';

export function useDashboardStats(period: '7d' | '30d' | '90d') {
  return useQuery({
    queryKey: ['dashboard', 'stats', period],
    queryFn: () => dashboardApi.stats(period),
    select: (res) => res.data.data,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}

export function useRecentDispatches() {
  return useQuery({
    queryKey: ['dashboard', 'recent-dispatches'],
    queryFn: () => dispatchesApi.list({ pageSize: 10 }),
    select: (res) => res.data.data,
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
